import { render, staticRenderFns } from "./CharactersPage.vue?vue&type=template&id=7221c035&scoped=true"
import script from "./CharactersPage.vue?vue&type=script&lang=ts"
export * from "./CharactersPage.vue?vue&type=script&lang=ts"
import style0 from "./CharactersPage.vue?vue&type=style&index=0&id=7221c035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7221c035",
  null
  
)

export default component.exports